import * as actions from "../actions/actions"

const initialState = {
    userStats: null,
    bankStats: null,
    fileStats: null,
    error: null,
    files:null
}

export default function Index(state = initialState, action) {
    switch (action.type) {
        case actions.FETCH_USER_STATS_SUCCESS:
            return fetchUserStatsSuccess(state,action)
        case actions.FETCH_USER_STATS_FAILURE:
            return fetchError(state,action)
        case actions.FETCH_BANK_STATS_SUCCESS:
            return fetchBankStatsSuccess(state,action)
        case actions.FETCH_BANK_STATS_FAILURE:
            return fetchError(state,action)
        case actions.FETCH_FILE_STATS_SUCCESS:
            return fetchFileStatsSuccess(state,action)
        case actions.FETCH_FILE_STATS_FAILURE:
            return fetchError(state,action)
        default:
            return state

    }
}

const fetchUserStatsSuccess = (state,action) => {
    return {
        ...state,
        userStats: action.userStats
    }
}

const fetchBankStatsSuccess = (state,action) => {
    return {
        ...state,
        bankStats: action.bankStats
    }
}

const fetchFileStatsSuccess = (state,action) => {
    return {
        ...state,
        fileStats: action.fileStats
    }
}

const fetchError = (state, action) => {
    return {
        ...state,
        error: action.error
    }
}